import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { LeaseRentersInsuranceSettingsRepository } from '~/repositories/settings/leaseRentersInsuranceSettingsRepository';

export const [LeaseRentersInsuranceSettingsProvider, useLeaseRentersInsuranceSettings] = createMagicDoorContext(
  'LeaseRentersInsuranceSettings',
  () => {
    const repo = new LeaseRentersInsuranceSettingsRepository();

    const [isLoading, setIsLoading] = createSignal(false);
    const [error, setError] = createSignal<Error | undefined>(undefined);
    const [allLeaseRentersInsuranceSettings, setAllLeaseRentersInsuranceSettings] = createSignal<
      MagicDoor.Api.LeaseRentersInsuranceSettingsDtoSettingsWithOverridesDto | undefined
    >();

    const getAllLeaseRentersInsuranceSettings = async () => {
      try {
        setIsLoading(true);
        const json = await repo.getAllLeaseRentersInsuranceSettings();
        setAllLeaseRentersInsuranceSettings(json);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const updateLeaseRentersInsuranceSettings = async (payload: MagicDoor.Api.LeaseRentersInsuranceSettingsDto) => {
      try {
        setIsLoading(true);
        await repo.updateLeaseRentersInsuranceSettings(payload);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const updateOverrideLeaseRentersInsuranceSettings = async (
      level: string,
      levelId: string,
      payload: MagicDoor.Api.LeaseRentersInsuranceSettingsDto
    ) => {
      try {
        setIsLoading(true);
        await repo.updateLeaseRentersInsuranceSettingsByLevel(level, levelId, payload);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const addOverrideRentersInsuranceSettings = async (
      level: string,
      levelId: string,
      payload: MagicDoor.Api.LeaseRentersInsuranceSettingsDto
    ) => {
      try {
        setIsLoading(true);
        await repo.updateLeaseRentersInsuranceSettingsByLevel(level, levelId, payload);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const removeOverrideRentersInsuranceSettings = async (level: string, levelId: string) => {
      try {
        setIsLoading(true);
        await repo.deleteLeaseRentersInsuranceSettingsByLevel(level, levelId);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    return {
      error,
      isLoading,
      allLeaseRentersInsuranceSettings,
      getAllLeaseRentersInsuranceSettings,
      updateLeaseRentersInsuranceSettings,
      addOverrideRentersInsuranceSettings,
      updateOverrideLeaseRentersInsuranceSettings,
      removeOverrideRentersInsuranceSettings,
    };
  }
);
